// extracted by mini-css-extract-plugin
export default {"colorline":"bKUbrWqb","title":"M6sZCZpY"};